import React, { useEffect, useState, useCallback } from "react";
import UserApi from "service/userApi";
import "react-dropdown/style.css";
import LayoutV2 from "containers/LayoutV2";
import { formatDayMonth } from "utils/formatDate";
import ChiTietLog from "components/CommonComponent/ChiTietLog";
import SearchForm from "./SearchForm";
import LogTable from "./LogTable";
import PaginationSection from "./PaginationSection";
import DanhSachLogApi from "service/danhSachLogApi";

const DanhSachLog = () => {
  const [showChiTietLog, setShowChiTietLog] = useState(false);
  const [logDetail, setLogDetail] = useState({});
  const [hasPermission, setHasPermission] = useState(null);

  const [dataSearch, setDataSearch] = useState({
    sUser: "",
    sNote: "",
    sStartDate: null,
    sEndDate: null,
    pageIndex: 1,
    pageSize: 20,
  });

  const [list, setList] = useState([]);
  const [iTotal, setITotal] = useState(0);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    document.title = "Quản lý log | Phần mềm quản lý cầm đồ Morman";
    const fetchPermission = async () => {
      try {
        const res = await UserApi.getAllQuyen();
        const roles = res.data.map((item) => item.ModuleCode.toLowerCase());
        setHasPermission(roles.includes("quanlylog"));
      } catch (err) {
        console.error("Lỗi load quyền:", err);
        setHasPermission(false);
      }
    };
    fetchPermission();
  }, []);


  const loadDanhSachLog = useCallback(async (searchData,page) => {
    try {
      setLoading(true);
      const payload = {
        ...searchData,
        sStartDate: searchData.sStartDate
          ? formatDayMonth(searchData.sStartDate)
          : undefined,
        sEndDate: searchData.sEndDate
          ? formatDayMonth(searchData.sEndDate)
          : undefined,
        pageIndex: page,
      };

      const res = await DanhSachLogApi.list(payload);
      // console.log("API Response:", res.data);

      setList(res.data.List || []);
      setITotal(res.data.iTotal || 0);
      setDataSearch((prev) => ({ ...prev, pageIndex: page }));

      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } catch (error) {
      console.error("Lỗi load danh sách log:", error);
    } finally {
      setLoading(false);
    }
  }, []);


  useEffect(() => {
    if (hasPermission) {
      loadDanhSachLog(dataSearch,1);
    }
  }, [hasPermission]);


  const onChangeData = (field) => (event) => {
    const value = event?.target?.value ?? "";
    setDataSearch((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const onChangeDate = (field) => (value) => {
    setDataSearch((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const onSearch = () => {
    loadDanhSachLog(dataSearch,1);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      loadDanhSachLog(dataSearch,1);
    }
  };

  const setModalChiTietLogShow = (logDetail) => {
    setShowChiTietLog(true);
    setLogDetail(logDetail);
  };

  const handlePageChange = (pageNumber) => {
    loadDanhSachLog(dataSearch,pageNumber);
  };


  if (hasPermission === null) {
    return (
      <LayoutV2>
        <div className="loader loader-default is-active"></div>
      </LayoutV2>
    );
  }
  if (hasPermission === false) {
    return (
      <LayoutV2>
        <h2 className="text-danger">
          <div className="custom-table-row">
            <div
              className="custom-table-cell text-center red"
              style={{ width: "100%" }}
            >
              Bạn không có quyền truy cập trang này!
            </div>
          </div>
        </h2>
      </LayoutV2>
    );
  }

  return (
    <LayoutV2>
      <div id="form-repeater">
        <div className="sticky-moman-bh">
          <div className="col-12">
            <div className="camdo-home">
              <div className="breadcrumb-new">
                <div className="row">
                  <div className="col-sm-12 col-md-12 title-cd">
                    <div className="media-home align-center-home">
                      <div className="row header">
                        <img
                          src="/app-assets/images/logo-ghi-chu-v2.png"
                          alt="logo"
                        />
                        <h1 className="text-info-home">Quản lý log</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="card border-light mb-3 hidden-mobile-main show-table-main card-v2"
                style={{ marginTop: "-8px" }}
              >
                <div className="card-body card-body-v2">
                  <SearchForm
                    dataSearch={dataSearch}
                    onChangeData={onChangeData}
                    onChangeDate={onChangeDate}
                    onSearch={onSearch}
                    handleKeyDown={handleKeyDown}
                  />
                </div>
              </div>
              <div
                className="card border-light mb-3 card-v2"
                style={{ marginTop: "-35px" }}
              >
                <div className="card-body card-body-v2">
                  <LogTable
                    list={list}
                    pageIndex={dataSearch.pageIndex}
                    pageSize={dataSearch.pageSize}
                    onShowDetail={setModalChiTietLogShow}
                    iTotal={iTotal}
                  />
                </div>
                <div
                  className="card border-light mb-3 card-v2"
                  style={{
                    marginLeft: "15px",
                    marginRight: "15px",
                    marginTop: "-25px",
                  }}
                >
                  <div className="card-body card-body-v2">
                    <PaginationSection
                      iTotal={iTotal}
                      dataSearch={dataSearch}
                      handlePageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ChiTietLog
          chitietlog={{ showModalLog: showChiTietLog }}
          showModalChiTietLog={() => setShowChiTietLog(false)}
          data={{
            CreatedByUser: logDetail?.CreatedUser,
            CreatedTime: logDetail ? logDetail.CreatedTime : "",
            Note: logDetail?.Note,
          }}
        />
      </div>
    </LayoutV2>
  );
};

export default DanhSachLog;
